/** QC: GOT samples dispatched without hand-over, daily (got-qc-handover.md, screen 3). */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { NoHandoverReportPage } from "@/features/got/components/handover-report-page";

const search = z.object({
  date: z.string().optional(),
  facilityId: z.number().int().optional(),
});

export const Route = createFileRoute("/_app/quality/got/handover/report")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("got.handover_send"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { facilities, selected } = useFacilities();
  return (
    <NoHandoverReportPage
      date={s.date}
      facilityId={s.facilityId ?? selected?.id ?? null}
      facilities={facilities}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
